import React, {Component} from 'react';
import Link, {navigateTo} from 'gatsby-link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './typeahead.module.scss';

class TypeaheadResults extends Component {
  state = {
    index: -1,
  };

  componentDidMount = () => {
    document.addEventListener('keydown', this.listen);
  };

  componentDidUpdate = prevProps => {
    const {results: previousResults} = prevProps;
    const {results} = this.props;
    if (results.length !== previousResults.length) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({index: -1});
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.listen);
  };

  listen = e => {
    const {results} = this.props;
    const {index} = this.state;
    const {which} = e;
    const ENTER = 13;
    const DOWN = 40;
    const UP = 38;
    const preventsDefault = which === DOWN || which === UP;
    let nextIndex = index;
    const scrollOpts = {block: 'nearest'};

    if (results.length > 0 && preventsDefault) {
      e.preventDefault();
    }

    if (which === DOWN) {
      nextIndex = Math.min(index + 1, results.length - 1);
    }

    if (which === UP) {
      nextIndex = Math.max(0, index - 1);
    }

    if (which === ENTER && index >= 0) {
      navigateTo(results[index].url);
      return;
    }

    if (index === nextIndex) {
      return;
    }

    this.setState({index: nextIndex}, () => {
      if (!this.element) {
        return;
      }
      const children = this.element.getElementsByClassName('result');
      children[nextIndex].scrollIntoView(scrollOpts);
    });
  };

  setElement = node => {
    this.element = node;
  };

  renderText() {
    const {results} = this.props;
    if (results.length > 0) {
      return 'Top article suggestions';
    }
    return 'No results found';
  }

  render() {
    const {query, results, className} = this.props;
    const {index: current} = this.state;

    return (
      <div
        className={classNames(
          'navbar-dropdown',
          styles.TypeaheadResults,
          {
            [styles['TypeaheadResults--active']]: query.length > 0,
          },
          className
        )}
        ref={this.setElement}
      >
        <div className="navbar-item has-text-grey is-size-6">
          {this.renderText()}
        </div>
        <hr
          className={classNames(styles.TypeaheadResults__separator, {
            'is-hidden': results.length === 0,
          })}
        />
        <div className={styles.TypeaheadResults__scrollBox}>
          {results.map(({name, url}, index) => (
            <Link
              className={classNames('navbar-item result has-text-dark', {
                [styles['TypeaheadResult--active']]: index === current,
              })}
              key={url}
              to={url}
            >
              {name}
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

TypeaheadResults.propTypes = {
  className: PropTypes.string,
  query: PropTypes.string,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TypeaheadResults;



// WEBPACK FOOTER //
// ./src/components/search/TypeaheadResults.js